import { ACCOUNT_TYPE, type AccountType } from './account-type.constants';

export const ONBOARDING_PATHS = {
  accountType: 'account-type',
  yourDetails: 'your-details',
  accountUsage: 'account-usage',
  verification: 'verification',
  companyDetails: 'company-details',
  directorsUbos: 'directors-ubos',
  businessAccountUsage: 'business-account-usage',
  businessVerification: 'business-verification',
} as const;

export type OnboardingPath = (typeof ONBOARDING_PATHS)[keyof typeof ONBOARDING_PATHS];

export const PERSONAL_ONBOARDING_FLOW: readonly OnboardingPath[] = [
  ONBOARDING_PATHS.accountType,
  ONBOARDING_PATHS.yourDetails,
  ONBOARDING_PATHS.accountUsage,
  ONBOARDING_PATHS.verification,
];

export const BUSINESS_ONBOARDING_FLOW: readonly OnboardingPath[] = [
  ONBOARDING_PATHS.accountType,
  ONBOARDING_PATHS.companyDetails,
  ONBOARDING_PATHS.directorsUbos,
  ONBOARDING_PATHS.businessAccountUsage,
  ONBOARDING_PATHS.businessVerification,
];

export function resolveOnboardingResumeStep(
  serverStep: OnboardingPath,
  accountType: AccountType | null,
): OnboardingPath {
  const flow = accountType === ACCOUNT_TYPE.Business
      ? BUSINESS_ONBOARDING_FLOW
      : accountType === ACCOUNT_TYPE.Personal
        ? PERSONAL_ONBOARDING_FLOW
        : null;

  if (!flow) {
    return serverStep;
  }

  const serverIndex = flow.indexOf(serverStep);

  if (serverIndex === -1) {
    return ONBOARDING_PATHS.accountType;
  }

  return serverStep;
}

export const ONBOARDING_PATH_STEP: Record<OnboardingPath, number> = {
  [ONBOARDING_PATHS.accountType]: 2,
  [ONBOARDING_PATHS.yourDetails]: 3,
  [ONBOARDING_PATHS.accountUsage]: 4,
  [ONBOARDING_PATHS.verification]: 5,
  [ONBOARDING_PATHS.companyDetails]: 3,
  [ONBOARDING_PATHS.directorsUbos]: 4,
  [ONBOARDING_PATHS.businessAccountUsage]: 5,
  [ONBOARDING_PATHS.businessVerification]: 6,
};
